import React from 'react'

export default function Terms() {
  return (
    <div className='homeContainer'>
        <h3>Terms and Conditions for Registration and Data Collection</h3>

<h5>1. Introduction</h5>
<p>Welcome to MotorClaims Database. By registering and providing your personal data, you agree to comply with and be bound by these Terms and Conditions. We are committed to protecting your personal data in accordance with the Data Protection Act, 2019 (Kenya).</p>

<h5>2. Data Collection and Usage</h5>
<p>When you register with us, we may collect the following personal information:</p>
<ul>
    <li>Full Name</li>
    <li>Contact Information (Phone Number, Email Address)</li>
    <li>Identification Details (ID/Passport Number where applicable)</li>
    <li>Location Information</li>
    <li>Any other information relevant to our services</li>
</ul>
<p>Your data will be used for:</p>
<ul>
    <li>Claim registration and processing</li>
    <li>Communication regarding our services</li>
    <li>Marketing and promotional activities (with your consent)</li>
    <li>Compliance with legal and regulatory requirements</li>
</ul>

<h5>3. Data Protection and Privacy</h5>
<p>We handle your personal data in accordance with the Data Protection Act, 2019 (Kenya), ensuring:</p>
<ul>
    <li>Lawful, fair, and transparent processing of personal data</li>
    <li>Data collection is limited to what is necessary</li>
    <li>Data accuracy and integrity</li>
    <li>Secure storage and protection from unauthorized access</li>
    <li>Compliance with data subject rights</li>
</ul>

<h5>4. Data Sharing and Third-Party Disclosure</h5>
<p>We do not sell or rent your personal data. However, your data may be shared with:</p>
<ul>
    <li>Service providers assisting in claims management</li>
    <li>Regulatory authorities as required by law</li>
    <li>Partners for promotional activities (only with your consent)</li>
</ul>

<h5>5. Data Subject Rights</h5>
<p>Under the Data Protection Act, 2019 (Kenya), you have the following rights:</p>
<ul>
    <li>Right to be informed about how your data is used</li>
    <li>Right to access your personal data</li>
    <li>Right to correction or deletion of your data</li>
    <li>Right to withdraw consent for data processing</li>
    <li>Right to object to direct marketing</li>
    <li>Right to data portability</li>
</ul>

<h5>6. Data Retention</h5>
<p>We will retain your personal data for as long as necessary to fulfill the purposes outlined in these Terms and Conditions. Once data is no longer needed, it will be securely deleted.</p>

<h5>7. Security Measures</h5>
<p>We implement appropriate security measures to protect your personal data, including encryption, access control, and regular security assessments.</p>

<h5>8. Changes to Terms and Conditions</h5>
<p>We may update these Terms and Conditions from time to time. Any changes will be communicated through our website or other official communication channels.</p>

<h5>9. Contact Information</h5>
<p>If you have any questions regarding these Terms and Conditions or wish to exercise your rights, please contact us at:</p>
<ul>
    <li>Motor Claims</li>
    <li>Website: <a href="https://motorclaims.co.ke" target="_blank">https://motorclaims.co.ke</a></li>
    <li>Email: [Your Email Here]</li>
    <li>Phone: [Your Contact Number Here]</li>
</ul>

<p>By registering and providing your data, you acknowledge that you have read, understood, and agreed to these Terms and Conditions.</p>
      
    </div>
  )
}
